import Vue from 'vue'
import axios from 'axios'
import {
  LoadingProgrammatic as loading
} from 'buefy'

export default {
  init() {
    axios.defaults.baseURL = process.env.VUE_APP_API
    axios.defaults.withCredentials = true
  },
  async get(url, load = false, auth = true) {
    let loadingcomponent
    if (load) loadingcomponent = loading.open()
    let response
    try {
      response = await axios.get(`${url}`)
      if (load) loadingcomponent.close()
      return response
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 404) {
        if (load) loadingcomponent.close()
        return response
      } else {
        throw new Error(`ApiService ${error}`)
      }
    }
  },
  async post(url, params, load = true, auth = true) {
    let loadingcomponent
    if (load) loadingcomponent = loading.open()
    let response
    try {
      response = await axios.post(`${url}`, params)
      if (load) loadingcomponent.close()
      return response
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 404 || error.response.status === 400) {
        if (load) loadingcomponent.close()
        return error.response
      } else {
        throw new Error(`ApiService ${error}`)
      }
    }
  },
  getBase() {
    return axios.defaults.baseURL
  }
}
